"use client";
import { Eye } from "lucide-react";
import { useTranslation } from "react-i18next";

function MetricsCard({
  className,
  icon,
  upSkillNeeded,
  title,
  skillGapCritical,
  gapTitle,
  cardDescription,

  // section clicks
  onTitleClick,
  onDetailsClick,
  onViewDetailsClick,
}) {
  const { t } = useTranslation();

  const clickableProps = (handler) => {
    if (!handler) return {};
    return {
      role: "button",
      tabIndex: 0,
      onClick: (e) => {
        e.stopPropagation();
        handler();
      },
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          handler();
        }
      },
    };
  };

  return (
    <div className={className}>
      <div className="metric-header">
        <div className="metric-icon">{icon}</div>
      </div>

      <div className="metric-content">
        {/* Title block click */}
        <div
          className={onTitleClick ? "metric-clickable" : ""}
          {...clickableProps(onTitleClick)}
        >
          <h3>{upSkillNeeded}</h3>
          <p>{title}</p>
        </div>

        {/* Metric details click */}
        <div
          className={`metric-details ${onDetailsClick ? "metric-clickable" : ""}`}
          {...clickableProps(onDetailsClick)}
        >
          <span>
            {skillGapCritical} {gapTitle}
          </span>
        </div>

        {cardDescription && (
          <div className="metric-card-description">{cardDescription}</div>
        )}
      </div>

      {/* Footer click */}
      <div
        className={`metric-footer ${onViewDetailsClick ? "metric-clickable" : ""}`}
        {...clickableProps(onViewDetailsClick)}
      >
        <span>{t("dashboard.KeyPerformanceMetrics.viewDetails")}</span>
        <Eye size={14} />
      </div>
    </div>
  );
}

export default MetricsCard;
